import React from "react";
import get from "../../../../utils/get";

const TituloSection = (props) => {
  const {
    producto
  } = props;

  return (
    <div className="title">
      <h5>
        {get(producto, 'hotel.nombre')}
      </h5>
    </div>
  );
};

export default TituloSection;



// WEBPACK FOOTER //
// ./src/components/Hoteles/ProcesoCompraCdr/FichaReservaCdr/tituloSection.js